import { render, staticRenderFns } from "./BonusMulti1.vue?vue&type=template&id=57b28d0a&"
import script from "./BonusMulti1.vue?vue&type=script&lang=js&"
export * from "./BonusMulti1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports